@if (label) {
  <label
      [attr.for]="id + '-filename'"
      soho-label
      [required]="required$ | async"
      lm-label
      [layoutField]="field"
      [personalize]="personalize"
      lm-text-style
      [textStyle]="label?.textStyle">
    {{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
}
<div class="field">
  <div
      lm-field-options
      [hasContextMenu]="insertContextMenu && !displayAsText"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      [disableFieldOptions]="disableFieldOptions"
      [fieldAutomationId]="fieldAutomationId"
      soho-tooltip
      [popover]="true"
      [title]="popoverTitle"
      [placement]="'right'"
      [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
    <div>
      @if ((!isEmpty || displayAsText) && !modelField.missingImage) {
        @if (isXLUpload && !isXLUploadComplete && !displayAsText) {
          <!-- The xlupload field will be in this status only when it is not a display as text or readonly-->
          <span class="tag">
            <p class="tag-content"
                [attr.id]="id"
            >
              <span class="lm-tag-filename">{{modelField.valueChanged | async}}</span>
              <span class="lm-tag-status">{{xlUploadTagStatus}}</span>
            </p>
            @if (canCancelXLUpload) {
              <button
                  soho-button="icon"
                  icon="cancel"
                  soho-tooltip
                  cy-data="cancel-attachment"
                  [title]="cancelXLUploadTitle"
                  (click)="cancelXLUpload()">{{cancelXLUploadTitle}}</button>
            }
            @if (canRetryXLUpload) {
              <button
                  soho-button="icon"
                  icon="redo"
                  soho-tooltip
                  cy-data="retry-attachment"
                  [title]="retryXLUploadTitle"
                  (click)="retryXLUpload()">{{retryXLUploadTitle}}</button>
            }
          </span>
        } @else {
          <!-- modelField.value cannot be on it's own line, as this introduces extra spaces around the text strings -->
          @if (displayAsText) {
            <p
                [attr.id]="id"
                class="lm-text-data hide-white-space">{{modelField.valueChanged | async}}</p>
          }
          @if (!displayAsText) {
            <a
                [attr.tabindex]="0"
                [attr.aria-label]="'OpenAttachment' | translate"
                [attr.id]="id"
                [attr.target]="modelField.mimeType === 'application/pdf' ? '_blank' : null"
                [attr.download]="modelField.mimeType === 'application/pdf' ? null : modelField.value"
                class="hyperlink"
                href="{{url}}">{{modelField.valueChanged | async}}</a>
          }
          @if (!displayAsText && !(readOnly$ | async)) {
            <button
                soho-button="icon"
                icon="delete"
                soho-tooltip
                cy-data="delete-attachment"
                [title]="deleteAttachmentTitle"
                (click)="removeAttachment()">{{deleteAttachmentTitle}}</button>
          }
        }
      } @else {
        <input
            [ngClass]="fieldClassesString"
            accept="true"
            [id]="bindId"
            [name]="bindId"
            [attr.value]="modelField.missingImage ? '' : modelField.valueChanged | async"
            [attr.original]="originalValue"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [readonly]="(readOnly$ | async) ? true : null"
            soho-fileupload
            [attr.aria-describedby]="fieldDescriptionId"
            [tabbable]="true"
            soho-alert
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
            soho-trackdirty
            (dirty)="onDirty($event)"
            (pristine)="onPristine()"
            (afterResetDirty)="onAfterResetDirty($event)"
            (changeEvent)="onFileUploadChange($event)"
        />
      }
    </div>

  </div>
</div>
<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
  }
</ng-template>
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
